import React, { useEffect, useState } from "react";
import "./Pupup.css";

const WebPopup = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 4000); // 4 seconds delay

    return () => clearTimeout(timer); // cleanup
  }, []);

  return (
    <>
      {showModal && (
        <div className="webpopup-overlay">
          <div className="webpopup-container">
            <h2>Subscribe now!</h2>
            <p>Get <strong>full access</strong> to our exclusive property listings and updates.</p>
            <button onClick={() => setShowModal(false)} className="webpopup-button">
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default WebPopup;
